import { ArticleWithRelations, isArchived, RequestWithRelations } from '@/models/request';

const hasBeenExchanged = (
  article: ArticleWithRelations,
  allArticles: ArticleWithRelations[]
): boolean =>
  !!article.exchangeConfirmedAt && allArticles.some((a) => a.exchangedFromId === article.id);

export const getArticlesToDisplay = (request: RequestWithRelations) => {
  let articlesToDisplay: ArticleWithRelations[] = [];
  let articlesToPickup: ArticleWithRelations[] = [];

  if (isArchived(request)) {
    articlesToDisplay = request.allArticles;
  } else {
    const noneOrExchangeArchivalOrRefundArticles = request.archivedArticles.filter(
      (article) =>
        article.snapshot.serviceChoice === 'none' ||
        article.snapshot.serviceChoice === 'exchange-archival' ||
        article.snapshot.serviceChoice === 'refund'
    );

    articlesToPickup = request.articles.filter(
      (article) =>
        article.quoteRefusedAt &&
        !!request.storeId &&
        article.atEntityId === request.storeId &&
        article.toClient &&
        article.step?.step === 'transit' &&
        article.step.config.clientPickup
    );

    articlesToDisplay = [
      ...request.articles.filter((article) => !articlesToPickup.find((a) => a.id === article.id)),
      ...noneOrExchangeArchivalOrRefundArticles,
    ];
  }

  articlesToDisplay = articlesToDisplay.filter(
    (article) => !hasBeenExchanged(article, request.allArticles)
  );

  return { articlesToDisplay, articlesToPickup };
};
